"use strict"; // #region -------------- Filter -------------------------------------------------------------------

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ReportFilterOperationType;

(function (ReportFilterOperationType) {
  ReportFilterOperationType["EQUALS"] = "EQUALS";
  ReportFilterOperationType["NOT_EQUALS"] = "NOT_EQUALS";
  ReportFilterOperationType["STARTS_WITH"] = "STARTS_WITH";
  ReportFilterOperationType["NOT_STARTS_WITH"] = "NOT_STARTS_WITH";
  ReportFilterOperationType["ENDS_WITH"] = "ENDS_WITH";
  ReportFilterOperationType["NOT_ENDS_WITH"] = "NOT_ENDS_WITH";
  ReportFilterOperationType["CONTAINS"] = "CONTAINS";
  ReportFilterOperationType["NOT_CONTAINS"] = "NOT_CONTAINS";
  ReportFilterOperationType["ALL_IS_LESS"] = "ALL_IS_LESS";
  ReportFilterOperationType["ALL_IS_MORE"] = "ALL_IS_MORE";
  ReportFilterOperationType["AT_LEAST_ONE_IS_LESS"] = "AT_LEAST_ONE_IS_LESS";
  ReportFilterOperationType["AT_LEAST_ONE_IS_MORE"] = "AT_LEAST_ONE_IS_MORE";
  ReportFilterOperationType["IS_NULL"] = "IS_NULL";
  ReportFilterOperationType["IS_NOT_NULL"] = "IS_NOT_NULL";
})(ReportFilterOperationType = exports.ReportFilterOperationType || (exports.ReportFilterOperationType = {})); // #endregion
// #region -------------- Sorting -------------------------------------------------------------------


var ReportSortDirectionType;

(function (ReportSortDirectionType) {
  ReportSortDirectionType["ASC"] = "ASC";
  ReportSortDirectionType["DESC"] = "DESC";
})(ReportSortDirectionType = exports.ReportSortDirectionType || (exports.ReportSortDirectionType = {})); // #endregion
// #region -------------- Response -------------------------------------------------------------------


var ReportColumnType;

(function (ReportColumnType) {
  ReportColumnType["dimension"] = "dimension";
  ReportColumnType["metric"] = "metric";
})(ReportColumnType = exports.ReportColumnType || (exports.ReportColumnType = {}));